//
//
//
//
//
//
//
//

// 网络错误组件
export default {
  name: 'NotExist',
  data: function data() {
    return {
      title: '页面不存在'
    };
  },
  props: {},
  created: function created() {},
  destroyed: function destroyed() {},
  methods: {
    refresh: function refresh() {
      this.$emit('refreshEvent');
    }
  }
};